import cn from "classnames";
import React from "react";
import { LoadingDots } from "web-ui";

import type { LeaderboardParticipant } from "../api/languageChallenge";
import type { User } from "../api/v2";
import { apiV2 } from "../api/v2";
import medalBronze from "../images/medal-bronze.svg";
import medalGold from "../images/medal-gold.svg";
import medalSilver from "../images/medal-silver.svg";
import styles from "../styles/LeaderboardEntry.module.scss";

import Avatar from "./Avatar";

export interface Props {
  className?: string;
  participant: LeaderboardParticipant;
}
const LeaderboardEntry = ({ className, participant }: Props) => {
  const [user, setUser] = React.useState<User | null>(null);
  React.useEffect(() => {
    (async () => {
      setUser(await apiV2.getUser(participant.userId));
    })();
  }, [participant.userId]);

  if (!user) {
    return (
      <div className={cn(styles.wrap, className)}>
        <LoadingDots manualPositioning={true} type="screen-white" />
      </div>
    );
  }

  let medal: React.ReactNode | null;
  let rankClassName: string | null;

  switch (participant.rank) {
    case 1:
      medal = <img alt="Gold medal" className={styles.medal} src={medalGold} />;
      rankClassName = styles.gold;
      break;
    case 2:
      medal = (
        <img alt="Silver medal" className={styles.medal} src={medalSilver} />
      );
      rankClassName = styles.silver;
      break;
    case 3:
      medal = (
        <img alt="Bronze medal" className={styles.medal} src={medalBronze} />
      );
      rankClassName = styles.bronze;
      break;
    default:
      medal = null;
      rankClassName = null;
  }

  return (
    <div className={cn(styles.wrap, className)}>
      {medal}
      <h3 className={cn(styles["rank-number"], rankClassName)}>
        {participant.rank}
      </h3>
      <Avatar className={styles.avatar} user={user} />
      <div className={styles["name-column"]}>
        <h2 className={styles["primary-name"]}>{user.name ?? user.username}</h2>
        {participant.duolingoEmailPrefix && (
          <p className={styles["secondary-name"]}>
            {participant.duolingoEmailPrefix}@duolingo
          </p>
        )}
        {participant.sponsorDuolingoEmailPrefix && (
          <p className={styles["secondary-name"]}>
            Sponsor: {participant.sponsorDuolingoEmailPrefix}@duolingo
          </p>
        )}
      </div>
      <p className={styles["xp-text"]}>{participant.gainedXp} XP</p>
    </div>
  );
};
export default LeaderboardEntry;
